// extracted by mini-css-extract-plugin
export default {"wrapper":"Overview_style_wrapper__Q3bvq","steps":"Overview_style_steps__7xQ-u","item":"Overview_style_item__3cUzN","rotate":"Overview_style_rotate__7Q1BX"};